import { PointFeature } from '@/util/map-point-maps/types';

import { styles } from './UiKitPickupMarker.styles';

interface UiKitPickupMarkerProps {
  feature: PointFeature;
  onClick: (feature: PointFeature) => void;
  isSelected: boolean;
  type?: 'default' | 'shops';
}

export function UiKitPickupMarker({
  feature,
  onClick,
  isSelected,
  type = 'default'
}: UiKitPickupMarkerProps) {
  const slots = styles({ isSelected, type });

  const handleClick = () => {
    onClick(feature);
  };

  return (
    <button
      className={slots.marker()}
      onClick={handleClick}
    >
      <span className={slots.markerInner()} />
    </button>
  );
}
